import { FilterQuery } from './../dashboard/dashboard.component';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ApiResponseModel } from 'src/app/shared/models/api-response.model';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GraphsService {

  constructor(private http: HttpClient) { }

  getTotalSales(query: FilterQuery) {
    const params = new HttpParams()
      .set('from', query.from)
      .set('to', query.to)
      .set('filter', query.filter)
    return this.http.get<ApiResponseModel>(
      'api/dashboard/graph/total-sales', { params });
  }

  getInquiriesStatus(query: FilterQuery) {
    const params = new HttpParams()
      .set('from', query.from)
      .set('to', query.to)
      .set('filter', query.filter)
    return this.http.get<ApiResponseModel>(
      'api/dashboard/graph/inquiries-status', { params });
  }

  getInquiries(query: FilterQuery) {
    const params = new HttpParams()
      .set('from', query.from)
      .set('to', query.to)
      .set('filter', query.filter)
    return this.http.get<ApiResponseModel>(
      'api/dashboard/graph/inquiries', { params });
  }

  getVisitors(query: FilterQuery) {
    const params = new HttpParams()
      .set('from', query.from)
      .set('to', query.to)
      .set('filter', query.filter)
    return this.http.get<ApiResponseModel>(
      'api/dashboard/graph/visitors', { params });
  }

  getBookings(query: FilterQuery) {
    const params = new HttpParams()
      .set('from', query.from)
      .set('to', query.to)
      .set('filter', query.filter)
    return this.http.get<ApiResponseModel>(
      'api/dashboard/graph/bookings', { params });
  }

  getSalesChannelBreakdown(query: FilterQuery) {
    const params = new HttpParams()
      .set('from', query.from)
      .set('to', query.to)
      .set('filter', query.filter)
    return this.http.get<ApiResponseModel>(
      'api/dashboard/graph/sales-channel-breakdown', { params });
  }

  getInquiryChannelBreakdown(query: FilterQuery) {
    const params = new HttpParams()
      .set('from', query.from)
      .set('to', query.to)
      .set('filter', query.filter)
    return this.http.get<ApiResponseModel>(
      'api/dashboard/graph/inquiry-channel-breakdown', { params });
  }

  getSourceExcursionBreakdown(query: FilterQuery) {
    const params = new HttpParams()
      .set('from', query.from)
      .set('to', query.to)
      .set('filter', query.filter)
    return this.http.get<ApiResponseModel>(
      'api/dashboard/graph/source-excursion-breakdown', { params });
  }
}
